import {AdvertisementVastInput, Advertisements, Advertisement} from "../state/input";
import {
    AdvertisementVast,
    Advertisement as AdvertisementOutput,
    SourceAction
} from "../state/source";


import {VASTClient} from "vast-client";
//import MobileDetect from "mobile-detect";

// @ts-ignore
//import { urlHandler } from 'vast-client/src/url_handler';

import {buffers, TakeableChannel, Task} from "redux-saga";
import {AdvertisementAction} from "../state/types";
import {actionChannel, race, fork, put, take, delay, select, call} from "redux-saga/effects";
import {AppState} from "../state";
import {WaitingTime} from "../state/waitingtime";
import {GDPR} from "../state/gdpr";
import {gdpr} from "./gdpr";
import {
    AudioAdvertisementTiming,
    AudioAdvertisementTimingAddAction,
} from "../state/audioadvertisementtiming";
import {IsMobile} from "./utils";
import {ApiClient} from "../../../generated/ApiClient";


/**
 * https://ad.doubleclick.net/ddm/pfadx/N1018932.1914880EXTRA/B26352556.312308221;sz=0x0;ord=[timestamp];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;dcmt=text/xml;dc_sdk_apis=[APIFRAMEWORKS];dc_omid_p=[OMIDPARTNER];dc_vast=3;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ltd=
 * APIFRAMEWORKS
 *
 *
 * @param source
 * @param gdpr
 * @constructor
 */


const Vast = async (source: AdvertisementVastInput, gdpr?: GDPR) => {

    const vastClient = new VASTClient() as VASTClient;
    vastClient.getParser().addURLTemplateFilter(url => {
        url = url.replace("[timestamp]", new Date().getTime() + '').replace("%%ADFRND%%", new Date().getTime() + '');

        if (gdpr) {
            url = url.replace(/%5BGDPR%5D|\[GDPR]|\${GDPR}/gi, gdpr.gdprApplies ? '1' : '0')
                .replace(/%5BGDPRCONSENT%5D|\${GDPR_CONSENT_[0-9]+}/gi, gdpr.tcString)
        } else {
            url = url.replace(/%5BGDPR%5D|\[GDPR]|\${GDPR}/gi, '0')
                .replace(/%5BGDPRCONSENT%5D|\[GDPRCONSENT]|\${GDPR_CONSENT_[0-9]+}/gi, '')
        }
        return url;
    });

    const max = 2;
    for (let i = 0; i < max; i++) {
        try {
            const response = await vastClient.get(source.url);
            if (response.ads.length !== 0) {
                return {
                    id: source.id,
                    type: "AdvertisementVast",
                    content: response,
                    hours: source.hour
                } as AdvertisementVast
            }
        } catch (e) {
            if (i+1 !== max)
                await new Promise(r => setTimeout(r, 300));
        }
    }
    return null

}

export function* LoadAdvertisement(source: Advertisements, slug: string, uuid: string) {

    if (!source) {
        return [];
    }

    const advtime: WaitingTime = yield select((state: AppState) => state.waitingTime);
    const advplayed: AudioAdvertisementTiming[] = yield select((state: AppState) => state.audioAdvertisementTiming);
    const isMobile = IsMobile();

    const pruchod = source.filter(x => !!x && !!x.id && !!x.url && (isMobile ? x.onMobile : true) && x.type === 'vast')
        .filter((x) => {
            if (!x)
                return false;
            if (!x.hour)
                return true;
            const id = x.id;

            return !advplayed.some(y => {
                if (y.id === id && y.slug === slug) {
                    const d = new Date();

                    if (y.created) {
                        d.setTime(y.created +  Math.ceil((x.hour || 0) * 60 * 60 * 1000));
                        if (d < new Date())
                            return false;
                    } else {
                        d.setTime(y.validTo);
                        if (d > new Date())
                            return false;
                    }
                    return true;
                }
                return false;
            });
        })
        .map((item, index) => {
        return {...item, index}
    }).sort((x, y) => {
        const xPriority = x.priority || 1;
        const yPriority = x.priority || 1;
        if (xPriority === yPriority)
            return x.index - y.index;
        return xPriority - yPriority;
    });

    const outputData: AdvertisementVast[] = [];
    const usedAdvertisements:number[] = [];

    if (!pruchod.length)
        return [];

    const priorities = pruchod.map(x => x.priority!).reduce((x, y) => {
        if (x.indexOf(y) === -1)
            x.push(y);
        return x;
    }, [] as number[]);

    if (!priorities.length)
    {
        return [];
    }


    const advPriorities = priorities.reduce((summary, item) => {
        summary[item] = pruchod.filter(x => x.priority === item);
        return summary;
    }, {} as {[priority:number] : (Advertisement | {index:number})[]})

    if (priorities.length ===  0) {
        return [];
    }

    const hasGdpr: GDPR = yield call(gdpr);

    for(let priorityIndex = 0; priorityIndex < priorities.length; priorityIndex++) {

        const priority = priorities[priorityIndex];

        if (priority === 100 && outputData.length)
            return outputData;

        for (let advIndex = 0; advIndex < advPriorities[priority].length; advIndex++) {
            const now = advPriorities[priority][advIndex] as AdvertisementVastInput;

            const {output, timeout}: { output: AdvertisementVast | null | undefined, timeout: boolean } = yield race({
                output: Vast(now as AdvertisementVastInput, hasGdpr),
                timeout: delay(advtime.advloadtime),
            });

            const isRadiacz = now.url!.indexOf("radia.cz") > -1;
            usedAdvertisements.push(now.id);

            if (!timeout && output) {
                outputData.push(output);
                new ApiClient().postApiStatisticsPlayer({
                    frontWebStatisticsPlayerModel: {
                        uuid,
                        isMobile: IsMobile(),
                        state: `success_load_advertisement_definition_${isRadiacz ? 'radiacz' : 'impression'}`,
                    }
                }, {
                    credentials: "omit"
                });
                if (!now.nextEnabled)
                    return outputData;
                break;
            } else {
                new ApiClient().postApiStatisticsPlayer({
                    frontWebStatisticsPlayerModel: {
                        uuid,
                        isMobile: IsMobile(),
                        state: `error_load_advertisement_definition_${isRadiacz ? 'radiacz' : 'impression'}`,
                    }
                }, {
                    credentials: "omit"
                });
            }
        }

    }

    return outputData;
}

export function* ProcessAdvertisement(o: AdvertisementOutput, slug: string, uuid: string) {
    const {advtime}: {
        advtime: WaitingTime
    } = yield select((state: AppState) => ({advtime: state.waitingTime, id: state.id}));
    if (o) {

        const channel: TakeableChannel<AdvertisementAction> = yield actionChannel(['AdvertisementBegin', 'AdvertisementEnd', 'AdvertisementError', 'AdvertisementPlay'], buffers.sliding(3));

        const advBeginTask: Task = yield fork(function* () {
            yield delay(advtime.advloadtime);
            new ApiClient().postApiStatisticsPlayer({
                frontWebStatisticsPlayerModel: {
                    uuid,
                    isMobile: IsMobile(),
                    state: "error_prepare_advertisement",
                }
            }, {
                credentials: "omit"
            })
            yield put<AdvertisementAction>({
                type: "AdvertisementError",
                payload: "ERROR_PREPARE_ADVERTISEMENT"
            });
        });

        const advPlayTask: Task = yield fork(function* () {
            yield delay(advtime.advwaitingtime);
            new ApiClient().postApiStatisticsPlayer({
                frontWebStatisticsPlayerModel: {
                    uuid,
                    isMobile: IsMobile(),
                    state: "error_play_advertisement",
                }
            }, {
                credentials: "omit"
            })
            yield put<AdvertisementAction>({
                type: "AdvertisementError",
                payload: "ERROR_STARTPLAYING_ADVERTISEMENT"
            })
        })


        yield put<SourceAction>({
            type: "Source",
            payload: o
        });

        while (true) {
            const action: AdvertisementAction = yield take<AdvertisementAction>(channel);
            switch (action.type) {
                case 'AdvertisementError':
                    advPlayTask.cancel();
                    advBeginTask.cancel();
                    return false;
                case 'AdvertisementBegin':
                    advBeginTask.cancel();
                    break;
                case 'AdvertisementPlay':
                    advPlayTask.cancel();
                    new ApiClient().postApiStatisticsPlayer({
                        frontWebStatisticsPlayerModel: {
                            uuid,
                            isMobile: IsMobile(),
                            state: "playing_advertisement",
                        }
                    }, {
                        credentials: "omit"
                    })
                    break;
                case "AdvertisementEnd":
                    new ApiClient().postApiStatisticsPlayer({
                        frontWebStatisticsPlayerModel: {
                            uuid,
                            isMobile: IsMobile(),
                            state: "played_advertisement",
                        }
                    }, {
                        credentials: "omit"
                    });
                    const d = new Date();
                    if (!o.hours)
                        return true;

                    const time = d.getTime() ;
                    d.setTime(time + Math.ceil((o.hours || 0) * 60 * 60 * 1000) );

                    yield put<AudioAdvertisementTimingAddAction>({
                        type: "AudioAdvertisementTimingAdd",
                        payload: {
                            id: o.id,
                            validTo: d.getTime(),
                            created: new Date().getTime(),
                            slug: slug
                        }
                    });
                    return true;
                default:
                    return true;
            }
        }
    }
}

